
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { LocaleItemProps } from ".";
import { loading, find } from "store/locale";

interface ApiLocaleFindByIdInputProps {
    id: number;
}

type ApiLocaleFindOutputProps = OutputBaseProps<{ item: LocaleItemProps; }, ApiLocaleFindByIdInputProps>

export const apiLocaleFindById = async (data: ApiLocaleFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiLocaleFindOutputProps>(`/api/locale/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};


interface ApiLocaleFindByCodeInputProps {
    code: string;
}

export const apiLocaleFindByCode = async (data: ApiLocaleFindByCodeInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiLocaleFindOutputProps>(`/api/locale/code/${data.code}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};